export const SET_DATE_FIELD_ACTION = '@validarProcesso/SET_DATE_FIELD_ACTIONS';
export const SET_BUSCAR_DADOS_TABELA = '@validarProcesso/SET_BUSCAR_DADOS_TABELA';
export const SET_SIMPLE_VALIDAR_PROCESSO_ACTION = '@validarProcesso/SET_SIMPLE_VALIDAR_PROCESSO_ACTION';
export const SET_COMMON_ACTION = '@validarProcesso/SET_COMMON_ACTION';
export const LIST_IDS = '@validarProcesso/LIST_IDS';
export const SET_EXPORTAR_VALIDACAO_PROCESSOS = '@validarProcesso/SET_EXPORTAR_VALIDACAO_PROCESSOS';
export const SET_PROXIMA_FASE_PROCESSO = '@validarProcesso/SET_PROXIMA_FASE_PROCESSO';
